import React from "react";
import Routers from "../routers/Public/";
import { BrowserRouter as Router } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css';
import "@appkit4/styles/appkit.min.css";
import "@appkit4/react-components/dist/styles/appkit4-react.min.css";
import "../styles/main.css"
import { AppStateProvider } from "./context"
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
 import "ag-grid-community/styles/ag-theme-alpine.css";

function App() {

  return (
    <div className="App">
      <AppStateProvider>
        <Router>
          <Routers />
        </Router>
      </AppStateProvider>
    </div>
  );
}

export default App;
